<template>
  <div>
    <div v-if="goal">
      <h4>{{ goal.name }}</h4>
      <p>{{ trans('core.program') }}: {{ goal.program }}</p>
      <p>
        {{ goal.description }}
      </p>

      <div>
        <colloquium-rules
          :rules="goal.colloquiumRules"
          :total="goal.total_points"
        />
      </div>

      <div style="margin-bottom:10px">
        <span
          :class="goalAchieved(goal)"
          :style="{ color: goal.achieved ? '#4caf50' : '#b71c1c' }"
        /> {{ achievedToolTip }}
      </div>

      <small><i>{{ trans('event.activities_from_startdate',{ 'startdate':goal.start_date }) }}</i></small>
    </div>
    <div v-else>
      {{ trans('core.none') }}
    </div>

    <template v-if="goals.length > 1">
      <hr>
      <div class="row">
        <div class="col-xs-12 selection">
          <a
            v-for="(goal, index) in goals"
            :class="selected(index)"
            class="item"
            style="font-size:18px; cursor:pointer"
            @click="changeIndex(index)"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import ColloquiumRules from './ColloquiumRules'
import VTooltip from 'v-tooltip'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'ColloquiumView',
  components: { ColloquiumRules },
  props: {
    studentId: { required: true },
    url: { required: false, default: null },
  },
  data () {
    return {
      goals: [],
      index: null,

    }
  },
  computed: {

    goal () {
      if (this.index !== null && this.goals[this.index] !== 'undefined') {
        return this.goals[this.index]
      }

      return false
    },

    achievedToolTip () {
      return this.goal.name + ': ' + (
        this.goal.achieved
          ? Lang.get('core.achieved')
          : Lang.get('core.not_achieved')
      )
    },
    activeUrl () {
      if (this.url === null) {
        return `/colloquia/students/${this.studentId}/api`
      }

      return this.url
    },
  },
  mounted () {
    this.fetchData()
  },
  methods: {

    fetchData () {
      axios.get(this.activeUrl).then(({ data }) => {
        this.goals = data.data.data
        this.index = 0
      }).catch(error => defaultErrorMessage(error))
    },
    goalAchieved (goal) {
      return goal.achieved == 1 ? 'fa fa-check' : 'fa fa-times'
    },
    selected (index) {
      return index === this.index ? 'fa fa-circle' : 'fa fa-circle-o'
    },
    changeIndex (index) {
      this.index = index
    },
  },
}
</script>

<style scoped>
    .selection {
        display: inline-block;
        text-align: center
    }

    .item {
        margin-right: 5px;
        display: inline-block;
    }
</style>
